import { render, staticRenderFns } from "./FilesListTableHeader.vue?vue&type=template&id=b7a07916&scoped=true"
import script from "./FilesListTableHeader.vue?vue&type=script&lang=ts"
export * from "./FilesListTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./FilesListTableHeader.vue?vue&type=style&index=0&id=b7a07916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a07916",
  null
  
)

export default component.exports